import { useBooleanFlagValue } from "@openfeature/react-sdk";
export function useNonPrimaryGitDependencySupport() {
    return useBooleanFlagValue("non-primary-git-dependency-support", false);
}
